/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Services - Account and Contract
 * These services provide APIs to manage accounts and contracts.  a contract is an agreement that represents the terms and conditions that apply to a transaction. An account is a relationship between the merchant and the financial institution that processes transactions for that merchant.
 *
 * The version of the OpenAPI document: 9.1.6
 * 
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../../../../../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../../../../../base';
// @ts-ignore
import { ValidateStoreQuotes } from '../../../../../com/hcl/commerce/typescript/axios';
// @ts-ignore
import { ValidateStoreQuotesResponse } from '../../../../../com/hcl/commerce/typescript/axios';
/**
 * StoreQuotesValidateApi - axios parameter creator
 * @export
 */
export const StoreQuotesValidateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * validate store quotes
         * @summary validate store quotes details
         * @param {string} storeId The store identifier.
         * @param {ValidateStoreQuotes} [body] The body data required for the REST method.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeQuotesValidate: async (storeId: string, body?: ValidateStoreQuotes, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('storeQuotesValidate', 'storeId', storeId)
            const localVarPath = `/store/{storeId}/resources/quote/validate`
                .replace(`{${"storeId"}}`, String(storeId));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StoreQuotesValidateApi - functional programming interface
 * @export
 */
export const StoreQuotesValidateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StoreQuotesValidateApiAxiosParamCreator(configuration)
    return {
        /**
         * validate store quotes
         * @summary validate store quotes details
         * @param {string} storeId The store identifier.
         * @param {ValidateStoreQuotes} [body] The body data required for the REST method.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeQuotesValidate(storeId: string, body?: ValidateStoreQuotes, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateStoreQuotesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeQuotesValidate(storeId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StoreQuotesValidateApi - factory interface
 * @export
 */
export const StoreQuotesValidateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StoreQuotesValidateApiFp(configuration)
    return {
        /**
         * validate store quotes
         * @summary validate store quotes details
         * @param {string} storeId The store identifier.
         * @param {ValidateStoreQuotes} [body] The body data required for the REST method.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeQuotesValidate(storeId: string, body?: ValidateStoreQuotes, options?: any): AxiosPromise<ValidateStoreQuotesResponse> {
            return localVarFp.storeQuotesValidate(storeId, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StoreQuotesValidateApi - object-oriented interface
 * @export
 * @class StoreQuotesValidateApi
 * @extends {BaseAPI}
 */
export class StoreQuotesValidateApi extends BaseAPI {
    /**
     * validate store quotes
     * @summary validate store quotes details
     * @param {string} storeId The store identifier.
     * @param {ValidateStoreQuotes} [body] The body data required for the REST method.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreQuotesValidateApi
     */
    public storeQuotesValidate(storeId: string, body?: ValidateStoreQuotes, options?: any) {
        return StoreQuotesValidateApiFp(this.configuration).storeQuotesValidate(storeId, body, options).then((request) => request(this.axios, this.basePath));
    }
}
